import { render } from "./Request.vue?vue&type=template&id=8f2f0a1c&scoped=true"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"

import "./Request.vue?vue&type=style&index=0&id=8f2f0a1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2f0a1c"]])

export default __exports__